import React from 'react'
import { CreateUraPassword } from './.'
import { connect } from 'react-redux'
import { fetchCheckPassword, fetchCreateUraPass } from './ducks'
import { withRouter } from 'react-router-dom'

const mapStateToProps = ({ changeUraPassword, oidc }) => ({
  userInfo: oidc.user.profile,
  ...changeUraPassword
})

const mapDispatchToProps = dispatch => ({
  fetchCheckPassword: data => dispatch(fetchCheckPassword(data)),
  fetchCreateUraPass: data => dispatch(fetchCreateUraPass(data))
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(props => <CreateUraPassword {...props} />)
)



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/CreateUraPassword/CreateUraPasswordPage.js